import {SettingOutlined} from '@ant-design/icons'
import {Button as AntdButton, Col, Divider, Row, theme} from 'antd'
import React from 'react'
import {Outlet} from 'react-router-dom'
import {instance as projectsService} from '../../services/ProjectsService'
import {CalendarReminders} from '../calendarRemiders/CalendarReminders'
import {Reminders} from '../reminders/Reminders'

export function Project() {
  const {
    token: {controlHeightSM},
  } = theme.useToken()

  // const project = projectsService.database[0]

  return (
    <div>
      <Outlet />
    </div>
  )
}
